import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { IoClose } from 'react-icons/io5';
import { Box } from '@mui/material';

export default function ConfirmationDialog(props) {
  return (
    <React.Fragment>
      <Dialog
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle id="alert-dialog-title"></DialogTitle>
        <DialogContent>
          <Box sx={{ position: 'absolute', top: 10, right: 10, cursor: 'pointer', fontSize: '25px' }} onClick={props.handleClose}>
            <IoClose />
          </Box>
          <DialogContentText id="alert-dialog-description">Please confirm before proceeding</DialogContentText>
        </DialogContent>
        <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
          <Button size="small" color="secondary" variant="contained" onClick={props.handleSubmit}>
            Proceed
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
